// config/dashboardKeys.js — SUMBER TUNGGAL key dashboard untuk AI.
// Dipakai oleh:
//   - AIChat.js        → getDashboardKey(pathname) (resolusi key saat runtime)
//   - AIDataSources.js → dropdown pilihan key di SQL Mode
// Menambah dashboard baru ke sistem AI = cukup tambah SATU entri di sini.
//
// Field:
//   key       : key kanonik (huruf kecil, underscore) — HARUS sama dengan yang
//               dipakai di backend (DASHBOARD_TABLE, ai_sql_sources, dst).
//   label     : nama tampilan untuk dropdown.
//   pathMatch : substring URL yang menandai halaman ini (untuk getDashboardKey).
//               Set null bila halaman tidak punya rute data sendiri.

export const DASHBOARD_KEYS = [
  // solman_docs HARUS di atas solman: 'solman-docs' juga mengandung 'solman'.
  { key: 'solman_docs',       label: 'Solman Documents', pathMatch: 'solman-docs' },
  { key: 'solman',            label: 'SAP Solution Manager', pathMatch: 'solman' },
  { key: 'aws_billing',       label: 'AWS Billing',          pathMatch: 'aws-billing' },
  { key: 'aws_cloudtrail',    label: 'AWS CloudTrail',       pathMatch: 'aws-cloudtrail' },
  { key: 'aws_cost',          label: 'AWS Cost Explorer',    pathMatch: 'aws-cost' },
  { key: 'aws_inventory',     label: 'AWS Inventory',        pathMatch: 'aws-inventory' },
  { key: 'sap_usage',         label: 'SAP User Utilization', pathMatch: 'sap-usage' },
  { key: 'sap_roles',         label: 'SAP Role Maintenance', pathMatch: 'sap-roles' },
  { key: 'sap_basis_mon',     label: 'SAP Basis Monitor',    pathMatch: 'sap-basis' },
  // Mode KB (RAG), bukan text-to-SQL — dokumen naratif dikirim dashboard lewat
  // aiKbSap.js dan source-nya terdaftar di AI_KB_SOURCES (ai-service).
  // pathMatch menunggu halaman frontend-nya dibuat; sampai itu ada, source ini
  // tetap bisa dipilih manual di AI Data Sources.
  { key: 'sap_config',        label: 'SAP Configuration (SPRO)', pathMatch: 'sap-config' },
  { key: 'sap_customizing',   label: 'SAP Customizing & Enhancement', pathMatch: 'sap-customizing' },
  { key: 'ai_history',        label: 'AI Chat History',      pathMatch: 'ai-history' },
  { key: 'employee_overtime', label: 'Employee Overtime',    pathMatch: 'employee-overtime' },
  { key: 'notes', 	      label: 'Notes', 		     pathMatch: 'notes' },
  { key: 'm365',            label: 'Microsoft 365 License', pathMatch: 'm365' },
  { key: 'sdp',             label: 'ManageEngine SDP Cloud', pathMatch: 'sdp' },
  { key: 'netmap',             label: 'Network Topology', pathMatch: 'network-topology' },
];

// Resolusi pathname → key kanonik. Mengembalikan null bila tak ada yang cocok.
export function dashboardKeyForPath(pathname) {
  if (!pathname) return null;
  const hit = DASHBOARD_KEYS.find(d => d.pathMatch && pathname.includes(d.pathMatch));
  return hit ? hit.key : null;
}
